import cmblapi from 'cmblapi';
import moment from 'moment'
import md5 from "js-md5";
import YAML from 'yaml';
import axios from 'axios';
import AES from "@/unit/aes";
export default {
	isApp: ()=> {
		return isApp()
	},
  setTitle:(title)=>{
      let is = isApp()
      if(is){
          cmblapi.applet({
              api: 'setAppletTitle',
              params: {
                  title: title
              },
              success: function() {},
              fail: function(res) {
              }
          })
      }else{
          document.title = title
      }
  },
  //手机银行登录授权
  async merchantLogin(){
      const pubconfObj = await readPubconf()
      let corpNo = AES.decrypt(pubconfObj.cmb_merchant.crpno)
      let corpkey = AES.decrypt(pubconfObj.cmb_merchant.crpid)
      let timestamp = moment(new Date()).format("YYYYMMDDHHmmss") 
      let nonceStr =  getRandomString(30)
      let sign = md5(corpNo + timestamp + nonceStr + corpkey)
      cmblapi.merchantLogin({
          corpNo:corpNo,
          reAuth:false,
          authInfo:{
              timestamp:timestamp,
              nonceStr:nonceStr,
              sign:sign
          },
          success:function(res){
          // res结果如下:
          // {body ="xxx",cryptType = 2,resultType = Y}
          },
          fail:function(res){
          }
      })
  },
  arrContains:(arr, val)=>{
    return arrContains(arr,val)
  }
}

function isApp(){
    let userAgent = navigator.userAgent
    if(userAgent.indexOf('MPBank') > -1){
    	return true
    }else{
    	return false
    }
}
/**
 * 数组是否包含某项
 * @param {Object} arr
 * @param {Object} val
 */
function arrContains(arr, val) {
    return arr.some(item => item === val);
}



/**
 * 随机生成字符串
 * @param len 指定生成字符串长度
 */
function getRandomString(len){
    let _charStr = 'abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789',
        min = 0, 
        max = _charStr.length-1, 
        _str = '';                    //定义随机字符串 变量
    //判断是否指定长度，否则默认长度为15
    len = len || 15;
    //循环生成字符串
    for(var i = 0, index; i < len; i++){
        index = (function(randomIndexFunc, i){         
                    return randomIndexFunc(min, max, i, randomIndexFunc);
                })(function(min, max, i, _self){
                    let indexTemp = Math.floor(Math.random()*(max-min+1)+min),
                        numStart = _charStr.length - 10;
                    if(i==0&&indexTemp >=numStart){
                        indexTemp = _self(min, max, i, _self);
                    }
                    return indexTemp ;
                }, i);
        _str += _charStr[index];
    }
    return _str;
}

// // 读取文件，按照yaml格式解析
async function loadFileAsYaml(name) {
  const res = await axios.get(name);
  const fileStr = 200 === res.status ? res.data : null;
  return YAML.parse(fileStr); // 解析字符串得到的对象
}

// // 读取pub.conf
function readPubconf() {
  return loadFileAsYaml('/pub.conf');
}
